// Merged ar dictionary. Each area file is owned by one part of the app; later files win on a duplicate key.
import core from './core.js';
import shell from './shell.js';
import fieldA from './fieldA.js';
import fieldB from './fieldB.js';
import assets from './assets.js';
import auditsMaint from './auditsMaint.js';
import financeReports from './financeReports.js';
import reports from './reports.js';
import catalogueStock from './catalogueStock.js';
import registry from './registry.js';
import adminBilling from './adminBilling.js';
import apiErrors from './apiErrors.js';

export default { ...core, ...shell, ...fieldA, ...fieldB, ...assets, ...auditsMaint, ...financeReports, ...reports, ...catalogueStock, ...registry, ...adminBilling, ...apiErrors };
